import React from "react"

import LayoutSection from "../LayoutComponents/LayoutSection"
import LayoutItem from "../Layouts/LayoutItem"

import PillButton from "@components/elements/V2/Buttons/PillButton"
import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"

type Props = {
  header: string
  body?: string
  ctaLabel: string
  ctaLink: string | YocoCom.YocoLink
  mobileGridOrder?: number
}

const HeaderCTA = ({
  header,
  body,
  ctaLabel,
  ctaLink,
  mobileGridOrder,
  ...props
}: Props) => {
  return (
    <LayoutItem
      as={LayoutSection}
      primaryBackgroundColor={Color.White}
      mobileGridOrder={mobileGridOrder}
      {...props}
    >
      <div className="flex flex-col items-center justify-between text-center sm:flex-row sm:text-left">
        <div>
          <Typography
            text={header}
            size="h4"
            font="grotesk"
            weight="medium"
            color={Color.Black}
          />
          {body && (
            <Typography
              text={body}
              size="body-lg"
              font="grotesk"
              weight="book"
              color={Color.Charcoal}
              className="mt-10 max-w-5xl"
            />
          )}
        </div>

        <div className="mt-24 w-full sm:mt-4 sm:w-auto">
          <PillButton
            text={ctaLabel}
            style="solid"
            size="large"
            color={Color.Blue}
            linkUrl={ctaLink}
          />
        </div>
      </div>
    </LayoutItem>
  )
}

export default HeaderCTA
